import axios from 'axios'
import { ref } from 'vue'

const URLS = {
    xhr: {
        fetch: {
            billingHistory: '/api/profile/billing-history'
        }
    },
    icons: {
        bank: '/images/icons/bank.svg'
    },
    redirect: {
        stripeProfile: '/profile/stripe-profile'
    }
}
export const useArtistHistory = (userId, load) => {
    const artistBillingHistory = ref([])
    const artistBillingColumnDef = ref([
        {
            accessor: 'id',
            header: {
                classes: ['billing-header'],
                value: 'Invoice No.'
            },
            cell: {
                classes: ['invoice-cell', 'invoice-cell-id'],
                render: ({ val }) => `#${val}`
            },
            actions: {
                sortable: true
            }
        },
        {
            accessor: 'invoice_date',
            header: {
                classes: ['billing-header'],
                value: 'Invoice Date'
            },
            cell: {
                classes: ['invoice-cell', 'invoice-cell-date'],
                render: ({ val }) => val
            },
            actions: {
                sortable: true
            }
        },
        {
            accessor: 'type',
            header: {
                classes: ['billing-header'],
                value: 'Type'
            },
            cell: {
                classes: ['invoice-cell', 'invoice-cell-type'],
                render: ({ val }) => val[0].toUpperCase() + val.slice(1)
            },
            actions: {
                sortable: true
            }
        },
        {
            accessor: 'details',
            header: {
                classes: ['billing-header'],
                value: 'Details'
            },
            cell: {
                classes: ['invoice-cell', 'stack', 'white-text', 'invoice-cell-details'],
                render: ({ val }) => ({
                    name: val.name,
                    id: val.event_id,
                    title: val.event_title,
                    date: val.event_date,
                    event_published: val.event_published
                })
            },
            actions: {
                sortable: false
            }
        },
        {
            accessor: 'payment_info',
            header: {
                classes: ['billing-header'],
                value: 'Bank Account'
            },
            cell: {
                classes: ['invoice-cell', 'stack-center', 'invoice-cell-payment'],
                render: ({ val }) => ({
                    icon: URLS.icons.bank,
                    last4: val.last4 ? `*${val.last4}` : 'N/A'
                })
            },
            actions: {
                sortable: false
            }
        },
        {
            accessor: 'total_amount',
            header: {
                classes: ['billing-header'],
                value: 'Amount'
            },
            cell: {
                classes: ['invoice-cell', 'invoice-cell-amount'],
                render: ({ val, data }) => {
                    return {
                        val:
                            data.type === 'Refund'
                                ? `-$${parseFloat(val).toFixed(2)}`
                                : `$${parseFloat(val).toFixed(2)}`,
                        type: data.type,
                        status: data.status.status
                    }
                }
            },
            actions: {
                sortable: true
            }
        },
        {
            accessor: 'status',
            header: {
                classes: ['billing-header'],
                value: 'Status'
            },
            cell: {
                classes: ['invoice-cell', 'stack', 'invoice-cell-status'],
                render: ({ val }) => ({
                    status: val.status.replace(/_/g, ' '),
                    clear_date: val.clear_date
                })
            },
            actions: {
                sortable: true
            }
        }
    ])

    ;(async () => {
        if (!artistBillingHistory.value.length) {
            await _fetchArtistBillingHistory()
        }
    })()

    async function _fetchArtistBillingHistory() {
        try {
            load.value = true
            const response = await axios.get(`${URLS.xhr.fetch.billingHistory}/artist/${userId.value}`)
            artistBillingHistory.value = response.data.data
        } catch (error) {
            console.error(error)
        } finally {
            load.value = false
        }
    }
    return {
        artistBillingColumnDef,
        artistHistory: artistBillingHistory
    }
}
